import { Breadcrumb, JsonLd, JsonLdBreadcrumb, PageMetas } from '@interfaces/index';
import { DEFAULT_CMS_PAGE_METAS } from '@core/config';
import { SPS } from '@core/config/sps.config';
import { environment } from '../../../../environments/environment';

export class JsonLdBuilder {
  static buildJsonLd(metas: PageMetas, breadcrumbs: Breadcrumb[]): JsonLd {
    const jsonLd: JsonLd = {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: metas.title || DEFAULT_CMS_PAGE_METAS.title,
      abstract: metas.abstract || DEFAULT_CMS_PAGE_METAS.abstract,
      keywords: metas.keywords || DEFAULT_CMS_PAGE_METAS.keywords,
      breadcrumb: null,
      mainEntity: {
        '@type': 'Organisation',
        name: 'SPS Global',
        alternateName: 'SPS',
        description: metas.description || DEFAULT_CMS_PAGE_METAS.description,
        foundingLocation: 'Zurich',
        email: SPS.CONTACT_EMAIL,
        url: SPS.FE_PROD_URL,
        sameAs: Object.values(SPS.SOCIAL_MEDIA_PLATFORMS).map(({ url }) => url),
      },
    };

    // Append breadcrumbs if provided
    if (breadcrumbs?.length) {
      jsonLd.breadcrumb = {
        '@type': 'BreadcrumbList',
        itemListElement: this.buildBreadcrumbList(breadcrumbs),
      };
    }

    // Append geo coordinates if provided
    if (metas.geoCoordinates) {
      jsonLd.mainEntity.location = {
        '@type': 'Place',
        geo: {
          '@type': 'GeoCoordinates',
          latitude: Number(metas.geoCoordinates.latitude),
          longitude: Number(metas.geoCoordinates.longitude),
        },
      };
    }

    return jsonLd;
  }

  // Builds BreadcrumbList according to https://schema.org/BreadcrumbList
  static buildBreadcrumbList(breadcrumbs: Breadcrumb[]): JsonLdBreadcrumb[] {
    return (breadcrumbs || []).reduce(
      (p, breadcrumb, i) => [
        ...p,
        {
          '@type': 'ListItem',
          position: i + 1,
          item: {
            '@id': `${environment.apiHost}${breadcrumb.href}`,
            name: breadcrumb.label,
          },
        },
      ],
      []
    );
  }
}
